import { useNavigate, useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import DischargeChecklistList from 'components/dischargeChecklist/DischargeChecklistList';
import CircularProgress from 'components/shared/CircularProgress';
import { adminClientsQueryKeys, adminShowClient } from 'services/api/admin/clients';

// Admin > Clients > (three dot menu) > Discharge Checklist: the customer's screen pointed at a chosen
// client, so Olio staff can set it up before go-live. No flag check, unlike the customer page.
export default function AdminDischargeChecklist() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: client, isLoading } = useQuery({
    queryKey: adminClientsQueryKeys.show(id!),
    queryFn: ({ signal }) => adminShowClient(id!, signal),
    enabled: !!id,
  });

  // A client outside the admin's scope 404s here too, so this stops at the spinner instead of showing
  // an empty page with a live Add button.
  if (isLoading || !client) return <CircularProgress />;

  return (
    <DischargeChecklistList
      clientId={id}
      isAdmin
      title={`Discharge Checklist: ${client.name}`}
      onBack={() => navigate('/admin/clients')}
    />
  );
}
